import { Typography, TypographyTypeMap } from "@material-ui/core";
import { CommonProps } from "@material-ui/core/OverridableComponent";
import { useEffect, useRef, useState } from "react";
import { useResize } from "../../hooks/use-resize";
import LyfeTooltip from "../LyfeTooltip";

export function FlexierTypography(props: TypographyTypeMap["props"] & CommonProps<any>) {
	const { children, ...other } = props;
	const ref = useRef<HTMLElement>(null);
	const [isTooltipShown, setIsTooltipShown] = useState<boolean | null>(false);
	const { width } = useResize(ref);

	useEffect(() => {
		setIsTooltipShown(ref.current && ref.current.clientWidth < ref.current.scrollWidth);
	}, [width, ref.current]);

	return (
		<LyfeTooltip placement="right-start" title={isTooltipShown ? (children as string) : ""}>
			<div>
				<Typography innerRef={ref} {...other}>
					{children}
				</Typography>
			</div>
		</LyfeTooltip>
	);
}
